import { render, staticRenderFns } from "./FacebookLoginButton.vue?vue&type=template&id=95cde6fe&"
import script from "./FacebookLoginButton.vue?vue&type=script&lang=ts&"
export * from "./FacebookLoginButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports